export const browseApi = {
  data: {
    content: [
      {
        id: '009fb8f7-5c72-4a92-931b-ae97010c7dbf',
        type: 'PERSON',
        name: 'FileName-009fb8f7.csv',
        setting: {
          deduplicate: true,
          options: null,
        },
        labels: ['cb2e8867-0e17-4d4a-b541-28bcf3ab5fab'],
        state: 'PENDING',
        created: '2024-08-09T09:09:17.619+00:00',
        modified: '2024-08-09T09:09:17.619+00:00',
        statistics: {
          duplicated: 0,
          total: 980,
          failed: 0,
          processed: 950,
        },
      },
      {
        id: '009fb8f7-5c72-4a92-931b-ae97010c7rt8',
        type: 'PERSON',
        name: 'test.csv',
        setting: {
          deduplicate: true,
          options: null,
        },
        labels: ['cb2e8867-0e17-4d4a-b541-28bcf3ab5fab'],
        state: 'SUCCESS',
        created: '2024-08-09T09:09:17.619+00:00',
        modified: '2024-08-09T09:09:17.619+00:00',
        statistics: {
          duplicated: 0,
          total: 1000,
          failed: 0,
          processed: 900,
        },
      },
    ],
    pageable: {
      pageNumber: 0,
      pageSize: 5,
      sort: {
        empty: false,
        sorted: true,
        unsorted: false,
      },
      offset: 0,
      paged: true,
      unpaged: false,
    },
    last: true,
    totalElements: 1,
    totalPages: 1,
    size: 5,
    number: 0,
    sort: {
      empty: false,
      sorted: true,
      unsorted: false,
    },
    first: true,
    numberOfElements: 1,
    empty: false,
  },
  isLoading: false,
};
